/**
 * @generated SignedSource<<798fbd0beec3744ec4fe4985b18ee786>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarButtons_item$data = {
  readonly isSold: boolean | null;
  readonly isUnpurchasable: boolean | null;
  readonly saveSearchData: {
    readonly name: string | null;
    readonly page: string | null;
  } | null;
  readonly skus?: ReadonlyArray<{
    readonly displayInfo: {
      readonly ctas: {
        readonly showAcceptOffer: boolean | null;
        readonly showFollowCategory: boolean | null;
        readonly showMakeOffer: boolean | null;
        readonly showPurchase: boolean | null;
        readonly showRequestPrice: boolean | null;
      } | null;
    } | null;
    readonly serviceId: string | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactDealerButton_item" | "PdpSharedMakeOfferButton_item" | "PdpSharedPurchaseButton_item" | "PdpSharedShoppingButtons_item">;
  readonly " $fragmentType": "PdpRespSidebarButtons_item";
};
export type PdpRespSidebarButtons_item$key = {
  readonly " $data"?: PdpRespSidebarButtons_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarButtons_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarButtons_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUnpurchasable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SaveSearchDataType",
      "kind": "LinkedField",
      "name": "saveSearchData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "page",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPurchaseButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_item"
    },
    {
      "condition": "isMultiSku",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemSkuType",
          "kind": "LinkedField",
          "name": "skus",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "buyerId",
                  "variableName": "userId"
                },
                {
                  "kind": "Literal",
                  "name": "page",
                  "value": "pdp"
                }
              ],
              "concreteType": "SkuDisplayInfo",
              "kind": "LinkedField",
              "name": "displayInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CTADisplay",
                  "kind": "LinkedField",
                  "name": "ctas",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "showPurchase",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "showMakeOffer",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "showRequestPrice",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "showFollowCategory",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "showAcceptOffer",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShoppingButtons_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "de8c06b3ae396b6038388efb0fbd95fe";

export default node;
